var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-channel'),_c('list-channel'),_c('form-channel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }